import gsap from 'gsap';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

export class OverlayCaption {
  constructor(common, elem) {
    this.common = common;
    this.elem = elem;
    this.overlay = this.common.overlay;
    this.button = this.elem.querySelector('.b3-overlay-caption__button');
    this.buttonCircle = this.button.querySelector('.b3-overlay-caption__svg');
    this.content = this.elem.querySelector('.b3-overlay-caption__content');

    this.magnetic = document.querySelectorAll('.b3-magnetic-caption');

    this.splitText = new SplitText(this.content, {type: 'words', tag: 'span'});
    this.isOpen = false;

    this.init();
  }

  init() {
    gsap.set(this.splitText.words, {
      opacity: 0,
    });
    
    if (this.common.isMobile) {
      this.button.addEventListener('click', () => {
        if (!this.isOpen) {
          this.show();
        } else {
          this.hide();
        }
      });

      window.addEventListener('click', (e) => {
        let isTarget = e.target === this.button;
        if (this.isOpen && !isTarget) {
          this.hide();
        }
      });

      window.addEventListener('keydown', () => {
        if (this.isOpen) {
          this.hide();
        }
      });
    } else {
      this.button.addEventListener('mouseenter', () => {
        this.show();
      });
  
      this.button.addEventListener('mouseleave', () => {
        this.hide();
      });
  
      this.button.addEventListener('mousemove', (e) => {
        this.move(e);
      });
    }
  }

  show() {
    this.isOpen = true;

    gsap.fromTo(this.overlay, {
      opacity: 0,
    }, {
      opacity: 1,
      ease: 'power1.inOut',
      duration: 0.6,
      overwrite: true,
    });

    gsap.fromTo(this.splitText.words, {
      opacity: 0,
      y: 15,
    }, { 
      opacity: 1,
      y: 0,
      stagger: 0.01,
      ease: 'expo.out',
      duration: 0.8,
      overwrite: true,
    });

    const scale = this.buttonCircle.getBoundingClientRect().width / this.buttonCircle.offsetWidth;
    gsap.set(this.buttonCircle, { animation: 'none' });
    gsap.fromTo(this.buttonCircle, {
      scale: scale,
    }, {
      scale: 1,
      duration: 0.5,
      ease: 'power1.inOut',
    });

    if (this.magnetic.length) {
      gsap.to(this.magnetic, {
        opacity: 0,
        duration: 0.15,
        ease: 'none',
      });
    }
  }

  hide() {
    this.isOpen = false;

    gsap.to(this.overlay, {
      opacity: 0,
      ease: 'power1.inOut',
      duration: 0.6,
      overwrite: true,
    });

    gsap.to(this.button, {
      x: 0,
      y: 0,
      duration: 0.4,
      ease: 'power1.inOut',
    });

    gsap.set(this.buttonCircle, {
      animation: '',
    });

    gsap.to(this.splitText.words, {
      opacity: 0,
      y: 15,
      stagger: -0.01,
      ease: 'expo.out',
      duration: 0.6,
      overwrite: true,
    });

    if (this.magnetic.length) {
      gsap.to(this.magnetic, {
        opacity: 1,
        duration: 0.15,
        ease: 'none',
      });
    }
  }

  move(event) {
    const rect = event.target.getBoundingClientRect();
    const left = event.offsetX;
    const top = event.offsetY;
    const offsetFromCenterX = rect.width / 2 - left;
    const offsetFromCenterY = rect.height / 2 - top;
    const maxTranslate = 5;

    gsap.to(this.button, {
      x: () => -offsetFromCenterX * maxTranslate / rect.width,
      y: () => -offsetFromCenterY * maxTranslate / rect.height,
      duration: 0.2,
      ease: 'none',
    });
  }
}

export default class OverlayCaptionIterator {
  constructor(app) {
    this.overlayCaption = document.querySelectorAll('.b3-overlay-caption');

    if (this.overlayCaption.length) {
      this.overlayCaption.forEach(item => new OverlayCaption(app, item));
    }
  }
}